import type {
  CashierPaymentMethod,
  CashierPaymentMethodGroup,
  SavedPaymentAccountIdAndFields,
} from "@/api/cashier";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: {
  selectedPaymentMethod: CashierPaymentMethod | undefined;
  selectedPaymentMethodGroup: CashierPaymentMethodGroup | undefined;
  selectedSavedPaymentAccount: SavedPaymentAccountIdAndFields | undefined;
  paymentMethodList?: (CashierPaymentMethod | CashierPaymentMethodGroup)[];
} = {
  selectedPaymentMethod: undefined,
  selectedPaymentMethodGroup: undefined,
  selectedSavedPaymentAccount: undefined,
  paymentMethodList: undefined,
};

export const methodSlice = createSlice({
  name: "method",
  initialState,
  reducers: {
    setSelectedPaymentMethod: (
      state,
      action: PayloadAction<CashierPaymentMethod | undefined>
    ) => {
      state.selectedPaymentMethod = action.payload;
    },
    setSelectedPaymentMethodGroup: (
      state,
      action: PayloadAction<CashierPaymentMethodGroup | undefined>
    ) => {
      state.selectedPaymentMethodGroup = action.payload;
    },
    setSelectedSavedPaymentAccount: (
      state,
      action: PayloadAction<SavedPaymentAccountIdAndFields | undefined>
    ) => {
      state.selectedSavedPaymentAccount = action.payload;
    },
    setPaymentMethodList(
      state,
      action: PayloadAction<
        (CashierPaymentMethod | CashierPaymentMethodGroup)[] | undefined
      >
    ) {
      state.paymentMethodList = action.payload;
    },
  },
});

export const {
  setSelectedPaymentMethod,
  setSelectedPaymentMethodGroup,
  setSelectedSavedPaymentAccount,
  setPaymentMethodList,
} = methodSlice.actions;

export default methodSlice.reducer;
